export const defaultConnectionSettings = {};
export function makeConnectionId({ buyerProfileId, sellerProfileId, }) {
    return `${buyerProfileId}-${sellerProfileId}`;
}
//# sourceMappingURL=connections.js.map